import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import styles from "./UniVersialSearchModal.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const style = {
  position: "absolute" as "absolute",
  top: "10%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "rgba(255, 255, 255, .5)",

  border: "none",
  boxShadow: 24,

  p: 4,
};
const UniVersialSearchModal = (props: any) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    props.closeModal(false);
  };
  return (
    <>
      <div className={styles.modalCon}>
        <Modal
          open={true}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className={styles.searchBoxCon}>
              <ArrowBackIcon
                className={styles.arrowIcon}
                onClick={handleClose}
              />
              <input type="text" placeholder="Search" />
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default UniVersialSearchModal;
